'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _index = require('../sfdc-abstract-legend/index.js');

var _index2 = _interopRequireDefault(_index);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var layoutBuilder = _sdk2.default.layoutBuilder;

var ComboLegend = function (AbstractLegend) {
  function ComboLegend(config, topLegend, bottomLegend) {
    AbstractLegend.call(this, config);
    this._topLegend = topLegend;
    this._bottomLegend = bottomLegend;
  }

  if (AbstractLegend) ComboLegend.__proto__ = AbstractLegend;
  ComboLegend.prototype = (0, _create2.default)(AbstractLegend && AbstractLegend.prototype);
  ComboLegend.prototype.constructor = ComboLegend;

  ComboLegend.prototype.getTopLegend = function getTopLegend() {
    return this._topLegend;
  };

  ComboLegend.prototype.getBottomLegend = function getBottomLegend() {
    return this._bottomLegend;
  };

  ComboLegend.prototype.getLegends = function getLegends() {
    return [this._topLegend, this._bottomLegend];
  };

  ComboLegend.prototype.getVerticalSize = function getVerticalSize() {
    var width = 0;
    var height = 0;
    var sizes = [this._topLegend.getVerticalSize(), this._bottomLegend.getVerticalSize()];
    sizes.map(function (legendSize) {
      width = Math.max(legendSize[0], width);
      height += legendSize[1];
    });
    return [width, height];
  };

  ComboLegend.prototype.getHorizontalSize = function getHorizontalSize(chartSize) {
    var width = 0;
    var height = 0;
    var sizes = [this._topLegend.getHorizontalSize(chartSize), this._bottomLegend.getHorizontalSize(chartSize)];
    sizes.map(function (legendSize) {
      width += legendSize[0];
      height = Math.max(height, legendSize[1]);
    });
    return [width, height];
  };

  ComboLegend.prototype.render = function render() {
    var config = this.config;
    var transforms = config.transforms;
    var size = config.size;
    var selectMode = config.selectMode;
    var selectionKeyFct = config.selectionKeyFct;
    var position = config.position;
    var showBackground = config.showBackground;
    var theme = config.theme;
    var scene = layoutBuilder.build({
      layout: "ComboLegend",
      size: size,
      position: position,
      transforms: transforms,
      selectMode: selectMode,
      selectionKeyFct: selectionKeyFct
    });
    var topLegendCell = scene.cellByKey("topLegend");
    var bottomLegendCell = scene.cellByKey("bottomLegend");
    var bottomHeaderCell = scene.cellByKey("bottomHeader");

    this._adjustSubLegendSize();

    var topLegendScene = this._topLegend.render();

    if (topLegendScene) {
      topLegendScene.exportIntoCell(topLegendCell, {
        keyPrefix: "radial"
      });
    }

    scene.adjustRowToFit(topLegendCell.get("row"));

    this._bottomLegend.render(bottomHeaderCell, bottomLegendCell);

    scene.adjustRowToFit(topLegendCell.get("row"));
    scene.adjustColumnToFit(topLegendCell.get("column")); // background

    if (showBackground) {
      scene.set({
        background: theme.getLegendBGColor()
      });
    }

    return scene;
  };

  ComboLegend.prototype._adjustSubLegendSize = function _adjustSubLegendSize() {
    var ref = this.config;
    var size = ref.size;
    var transforms = ref.transforms;
    var horizontalLayout = transforms.rotate;

    if (horizontalLayout) {
      var leftWidth = this._topLegend.getHorizontalSize()[0];

      var rightWidth = this._bottomLegend.getHorizontalSize()[0];

      var r;

      if (leftWidth + rightWidth > size[0]) {
        // overflow
        r = 1;
      } else {
        // both legend fits
        r = leftWidth / rightWidth;
      }

      rightWidth = size[0] / (r + 1);
      leftWidth = size[0] - rightWidth;

      this._topLegend.extendConfig({
        size: [leftWidth, size[1]],
        transforms: transforms
      });

      this._bottomLegend.extendConfig({
        size: [rightWidth, size[1]],
        transforms: transforms
      });
    } else {
      var topHeight = this._topLegend.getVerticalSize()[1];

      var bottomHeight = this._bottomLegend.getVerticalSize()[1];

      var r$1;

      if (topHeight + bottomHeight > size[1]) {
        // overflow
        r$1 = 1;
      } else {
        // both legend fits
        r$1 = topHeight / bottomHeight;
      }

      bottomHeight = size[1] / (r$1 + 1);
      topHeight = size[1] - bottomHeight;

      this._topLegend.extendConfig({
        size: [size[0], topHeight],
        transforms: transforms
      });

      this._bottomLegend.extendConfig({
        size: [size[0], bottomHeight],
        transforms: transforms
      });
    }
  };

  return ComboLegend;
}(_index2.default);

exports.default = ComboLegend;

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;